'use client'

import { ChevronRight } from 'lucide-react'
import type { AreaType } from '@/types/area-type'
import { HomeLink } from '@/components/home-link'
import { Button } from '@/components/ui/button'

export default function AreasGroup({ areas }: { areas: AreaType[] }) {
  return (
    <section className="container pt-17">
      <div className="flex flex-wrap items-end justify-between">
        <div className="max-w-[40.834375rem]">
          <h2 className="font-bold text-3.5xl text-primary-900 leading-10 md:text-4.5xl">
            Encontre o que busca por área. Uma lista feita a mão pra você amar.
          </h2>
        </div>

        <div className="mt-4 max-w-53.5 md:min-w-70">
          <Button asChild size="lg">
            <HomeLink
              className="flex items-center justify-between font-bold"
              href={'/cursos'}
            >
              Todos os cursos
              <ChevronRight />
            </HomeLink>
          </Button>
        </div>
      </div>

      <div
        className="mt-8 flex flex-wrap items-center justify-start gap-x-4 gap-y-2 border-gray-200 border-b-2 pb-17 md:gap-x-2.5 md:py-4 md:pb-20"
        id="areas-home"
      >
        {areas.map((area: AreaType) => (
          <Button
            className="p-8"
            key={area.reference}
            size="xl"
            type="button"
            variant="category"
          >
            <HomeLink
              className="flex w-full items-center gap-2"
              href={`/cursos/${area.url}`}
            >
              <span className="font-medium text-gray-800 text-lg md:text-2xl">
                {area.name}
              </span>
              <div className="rounded-full border border-gray-200 bg-transparent p-2 duration-200 group-hover:rotate-45">
                <ChevronRight className="size-5 transition-transform" />
              </div>
            </HomeLink>
          </Button>
        ))}
      </div>
    </section>
  )
}
